import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Draggable from "react-draggable";
import ButtonPrimary from "../../../components/button/ButtonPrimary";
import { toast } from "react-toastify";
import EmailInput from "../EmailBlock/EmailInput";
import { useIsMobile } from "../../../functions/isMobile";

const ShareBookmark = (props) => {
  const isMobile = useIsMobile();

  const [emailList, setEmailList] = useState([]);
  const [position, setPosition] = useState({
    marginTop: 0,
    marginLeft: 0,
  });
  const [containerHeight, setContainerHeight] = useState("0px");

  const {
    sharePopup,
    setSharePopup,
    shareCollectionFolder,
    setDarkBackground,
  } = props;

  // useEffect(() => {
  //   const lastPosition = JSON.parse(
  //     localStorage.getItem("shareBookmarkPosition")
  //   );
  //   if (lastPosition) {
  //     setPosition(lastPosition);
  //   }
  // }, []);

  const handleDrag = (e, ui) => {
    const { x, y } = ui;
    setPosition((prevPosition) => ({
      ...prevPosition,
      marginTop: y,
      marginLeft: x,
    }));
  };

  const handleSave = () => {
    if (emailList.length === 0) {
      toast.error(
        "Email field cannot be empty. Please enter a valid email and press 'Enter' before sharing."
      );
      return;
    } else {
      shareCollectionFolder(emailList);
      setEmailList([]);
    }

    setSharePopup(false);
    setPosition({ marginTop: 0, marginLeft: 0 });
    setEmailList([]);
  };

  const closePopup = () => {
    setSharePopup(false);
    setDarkBackground(false);
  };

  return (
    sharePopup && (
      <>
        {sharePopup && (
          <Draggable
            defaultPosition={{ x: position.marginLeft, y: position.marginTop }}
            onDrag={handleDrag}
            cancel={isMobile ? ".new-share-popup" : null}
          >
            <div className="new-share-popup">
              <div className="popup-card">
                <CloseIcon className="cross" onClick={closePopup} />

                <p className="popup-title">
                  Who would you like to share this Collection with?
                </p>
                <EmailInput
                  setMarginTop={(marginTop) =>
                    setPosition((prevPosition) => ({
                      ...prevPosition,
                      marginTop,
                    }))
                  }
                  emailList={emailList}
                  containerHeight={containerHeight}
                  setContainerHeight={setContainerHeight}
                  setEmailList={setEmailList}
                />
                <div className="save-actions">
                  <div />
                  <div className="flex">
                    <ButtonPrimary
                      text="Cancel"
                      onClick={closePopup}
                      className="mr-2 grey"
                      outline
                    />
                    <ButtonPrimary text="Share" onClick={handleSave} />
                  </div>
                </div>
              </div>
            </div>
          </Draggable>
        )}
      </>
    )
  );
};

export default ShareBookmark;
